<template>
  <div>
      <b-list-group-item
        class="p-0 mb-2 border-0 bg-light border-bottom"
      >
        <div class="row no-gutters">
          <div v-if="imageExist" class="col-2">
            <div :style="style" class="rounded-left">
              <b-aspect :aspect="aspect" />
            </div>
          </div>
          <div class="col-10 d-flex align-items-center px-3 pt-2">
            <div class="w-100 position-relative">
              <b-link href="#" :to="{ name: 'Article', params: { id: article.id } }" class="text-dark stretched-link">
                <h5>{{title}}</h5>
              </b-link>
              <p class="text-muted content-size" v-html="extractContent(article.content)"></p>
            </div>
          </div>
        </div>
      </b-list-group-item>
  </div>
</template>

<script  lang="ts">
import { mapState } from 'vuex'
import api from '@/api'
import { getAbsoluteURL, truncateString } from '@/tools'

import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    article: {
      type: Object,
      required: true,
    },
    aspect: {
      type: String,
      required: false,
      default: '16:9'
    },
    widget: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('auth', { storedUser: 'user' }),
    ...mapState('auth', ['loggedIn', 'user']),
    title(){
      const title = truncateString(this.article.title, (!this.widget ? 50 : 40))
      return title +  (title.length == (!this.widget ? 50 : 40) ? '...' : '')
    },
    date() {
      return new Date(this.article.date)
    },
    heure() {
      return this.date.getHours() + ':' + this.date.getMinutes() + ':' + this.date.getSeconds()
    },
    imageExist() {
      return this.article.thumbnail == "null" ? false : true
    },
    thumbnail() {
      return getAbsoluteURL(this.article.thumbnail)
    },
    style(){
      return {
        backgroundImage: 'url(' + this.thumbnail + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#e9e9e9'
      }
    }
  },
  methods: {
    extractContent (s) {
      const regex = /H[1-6]/gi
      const span = document.createElement('span');
      span.innerHTML = s;
      let content = ''
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      span.childNodes.forEach((n: any) => {
        if (!n.nodeName.match(regex)) {
          content += n.textContent
        }
      })
      return truncateString(content, 150 ) + "...";
    },
    deleted (id: number) {
      if (confirm(this.$t('confirm'))){
        api.blog.delete(id)
          .finally(() => {
            this.$emit('deleted')
            this.$root.$bvToast.toast(this.$t('toast.saveSuccess.body'), {
              variant: 'success',
              title: this.$t('toast.saveSuccess.title')
            })
          })
      }
    }
  }
})
</script>

<style>
  .content-size{
    font-size: 13px !important;
  }
</style>

<i18n>
  {
    "fr": {
      "confirm": "Voulez-vous supprimer cet article ?",
      "toast": {
        "saveSuccess": {
          "title": "Enregistré",
          "body": "Les modifications ont bien été enregistrées."
        }
      }
    },
    "en": {
      "confirm": "Are you sure you want to delete this article?",
      "toast": {
        "saveSuccess": {
          "title": "Saved",
          "body": "Edits have been saved."
        }
      }
    }
  }
</i18n>
